var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.content)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.content.replace(/(?:\r\n|\r|\n)/g, '<br />'))}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }